import { OrderModel,orderDetail1,OrderInvoices,OrderInvoceDetail } from "../../models/orders/order-list-model";
import * as XLSX from 'xlsx';
import orderServices from '../../services/orders/orderservice';
 
export const orderExport = async (orderIDs: number[]) => {
    if (!orderIDs || orderIDs.length === 0) {
        return;
    }
 
    try {
        const response: OrderModel[] = await orderServices.getorderExport({ orderIds: orderIDs });
        if (!response || response.length === 0) {
            return;
        }      
        generateExcelorder(response);
    } catch (error) {
        console.error(`Error fetching or exporting Order Data:`, error);
    }
};
 
const generateExcelorder = (orderList: OrderModel[]) => {
    const orderData = orderWiseData(orderList);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(orderData);
    XLSX.utils.sheet_add_aoa(ws, [
        ["Order#", "Total Value", "Handling Charges", "Courier Charges", "Packing Charges", "Payment Gateway Charges"]
    ], { origin: "A1" });
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'OrderListExport.xlsx');
};
 
const orderWiseData = (orderList: OrderModel[]) => {
    return orderList.map(order => ({
        "Order#": order.orderID,
        "Total_Value": Number(Math.round(order.total_Value ?? (order.taxableAmount + order.taxAmount))),
        "Handling_charges": Number(order.handlingCharges),
        "Courier_charges": Number(order.courierCharges),
        "Packing_charges": Number(order.packingCharges),
        "Payment_gateway_charges": Number(order.paymentGatewayCharges)
    }));
};
 
// export const detailExport = async (
//     orderID?: number,
//     invoiceNo?: number,
//     userID?: number,
//     orderType?: number,
//     startDate?: Date,
//     endDate?: Date
// ) => {
//     try {
//         const requestBody = {
//             orderID,
//             invoiceNo,
//             userID,
//             orderType,
//             startDate,
//             endDate
//         };
//         let response;
//         if (orderType && [1, 2].includes(orderType)) {
//             response = await orderServices.getOrderExportDetails(requestBody);
//         } else if (orderType && [3, 4, 5].includes(orderType)) {
//             response = await orderServices.getOrderInvoiceExportdetails(requestBody);
//         } else {
//             response = await orderServices.getOrderExportDetails(requestBody);
//         }
//         if (!response || response.orders.length === 0) {
//             console.warn('No data received from the API.');
//             return;
//         }
//         generateExcelorderDetails(response.orders);
//     } catch (error) {
//         console.error(`Error fetching or exporting Order Data:`, error);
//     }
// };

export const detailExport = async (
    orderID?: number,
    invoiceNo?: number,
    userID?: number,
    orderType?: number,
    startDate?: Date,
    endDate?: Date
) => {
    try {

        const requestBody = { orderID, invoiceNo, userID, orderType, startDate, endDate };

        if (orderType && [1, 2].includes(orderType)) {

            // ORDER EXPORT (server streaming Excel)
            await orderServices.getOrderExportdetailsStream(requestBody);

        } 
        else if (orderType && [3, 4, 5].includes(orderType)) {

            // INVOICE EXPORT (server streaming Excel)
            await orderServices.getOrderInvoiceExportdetailsStream(requestBody);

        } 
        else {

            // default export
            await orderServices.getOrderExportdetailsStream(requestBody);

        }

    } catch (error) {

        console.error("Error exporting order data:", error);

    }
};
 
const generateExcelorderDetails = (orderList: orderDetail1[]) => {
    if (!orderList || orderList.length === 0) {
        console.warn("No order data available for export.");
        return;
    }
    const orderData = orderWiseDatadetails(orderList);
    if (!orderData || orderData.length === 0) {
        console.warn("Processed data is empty.");
        return;
    }
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(orderData);
    XLSX.utils.sheet_add_aoa(ws, [
        ["Order#", "Bin No", "Order Date", "Order Status" ,"Order StatusType", "Invoice#", "Invoice Date", "User Name",
         "Mobile#", "Address", "Area Name", "SubDistrictName", "District", "State",
         "Country", "PinCode", "Route Code", "GPS Location", "GST #",
         "Main Category", "Sub Category", "HSN Code", "Product Name", "Unit Price",
         "Order Qty", "Invoice Qty", "Pending Qty", "Measurement Type Name", "Total Amount", "GST", "Tax Amount", "Gross Amount",
         "Handling Charges", "Packing Charges", "Courier Charges", "Payment Gateway Charges",
         "Invoice Amount", "Invoice Tax Amount", "Invoiced Total Amount", "Invoiced Discount Amount", "Pending Amount",
         "Pending Tax Amount", "Pending Total Amount",
         "Courier Provider", "Tracking #", "Order Payment Type", "Payment Status", "Bank RefNo",
         "Actual Payment Type", "Order UserName", "Ordered Contact", "Invoiced UserName", "Invoiced Contact",
         "Driver Contact", "Driver Name", "Sequence No", "Vehicle No"]
    ], { origin: "A1" });
   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'OrderDetailsListExport.xlsx');
 
};
 
const orderWiseDatadetails = (orderList: orderDetail1[]) => {
    return orderList.map(order => ({
        "Order#": order.orderID,
        "Bin No" : order.packingNo !== 0 ?  order.packingNo : "",
        "Order Date": formatDate(order.orderDate),
        "Order Status": order.orderStatus,
        "Order StatusType": order.orderStatusType,
        "Invoice#": order.invoiceNo || "",
        "Invoice Date": formatDate(order.invoiceDate),
        "User Name": order.userName,
        "Mobile#": order.mobile,
        "Address": order.address1 + ' ' + order.address2,
        "Area Name": order.areaName || "",
        "SubDistrictName": order.subDistrictName || "",
        "District": order.district || "",
        "State": order.state || "",
        "Country": order.country || "",
        "PinCode": order.pinCode || "",
        "Route Code": order.routeCode || "",
        "GPS Location": order.gpsLocation || "",
        "GST #": order.gstNumber || "",
        "Main Category": order.mainCategory || "",
        "Sub Category": order.subcategory || "",
        "HSN Code": order.hsnCode || "",
        "Product Name": order.productName || "",
        "Unit Price": order.unitPrice || 0,
        "Order Qty": order.orderQty || 0,
        "Invoice Qty": order.invoicedQuantity || 0,
        "Pending Qty": order.pendingQuantity || 0,
        "Measurement Type Name": order.measurementTypeName || "",
        "Total Amount": order.totalAmount || 0,
        "GST": order.gst || 0,
        "Tax Amount": order.tax || 0,
        "Gross Amount": Math.round(order.grossAmount) || 0,
        "Handling Charges": order.handlingCharges || 0,
        "Packing Charges": order.packingCharges || 0,
        "Courier Charges": order.courierCharges || 0,
        "Payment Gateway Charges": order.paymentGatewayCharges || 0,
        "Invoice Amount": order.invoiceamount || 0,
        "Invoice Tax Amount": order.invoicetaxAmount || 0,
        "Invoiced Total Amount": order.invoicedTotalAmount || 0,
        "Invoiced Discount Amount": order.discountAmount || 0,
        "Pending Amount": order.pendingAmount || 0,
        "Pending Tax Amount": order.pendingTaxAmount || 0,
        "Pending Total Amount": order.pendingTotalAmount || 0,
        "Courier Provider": order.courierProvider || "",
        "Tracking #": order.trackingNumber || "",    
        "Order Payment Type": order.orderPaymentType || "",
        "Payment Status": order.paymentStatus || "",
        "Bank RefNo": order.bankRefNo || "",
        "Actual Payment Type": order.actualPaymentType || "",
        "Order UserName": order.orderUserName || "",
        "Ordered Contact": order.orderedContact || "",
        "Invoiced UserName": order.invoicedUserName || "",
        "Invoiced Contact": order.invoicedContact || "",
        "Driver Contact":"",
        "Driver Name":"",
        "Sequence No":""
    }));
};
 
const formatDate = (dateString: string | null | undefined): string => {
    if (!dateString || dateString.startsWith("0001")) return "";
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? "" : date.toLocaleDateString('en-GB');
};
 
 
export const invoiceExport = async (orderIDs: number[]) => {
    if (!orderIDs || orderIDs.length === 0) {
        console.warn('No valid order IDs provided.');
        return;
    }
    try {
        const response: OrderInvoices[] = await orderServices.getInvoices({ orderIds: orderIDs });
 
        if (!response || response.length === 0) {
            console.warn('No data received from the API.');
            return;
        }
        generateExcelInvoice(response);
    } catch (error) {
        console.error(`Error fetching or exporting Order Data:`, error);
    }
};
 
const generateExcelInvoice = (orderList: OrderInvoices[]) => {
    const orderData = orderWiseInvoiceData(orderList);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(orderData);
    XLSX.utils.sheet_add_aoa(ws, [
        ["Order#", "Invoice#", "Invoice Date", "Total Value", "Handling Charges",
     "Courier Charges", "Packing Charges", "Payment Gateway Charges", "Discount Amount", "Gross Amount"]
    ], { origin: "A1" });
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'InvoiceListExport.xlsx');
 
};
 
const orderWiseInvoiceData = (orderList: OrderInvoices[]) => {
    return orderList.map(order => ({
       "Order#": order.orderID,
        "Invoice#": order.invoiceNo,
        "Invoice Date": new Date(order.invoiceDate).toLocaleDateString('en-gb'),
        "Total Value": Number(Math.round(order.totalValue)),
        "Handling Charges": Number(order.handlingCharges),
        "Courier Charges": Number(order.courierCharges),
        "Packing Charges": Number(order.packingCharges),
        "Payment Gateway Charges": Number(order.paymentGatewayCharges),
        "Discount Amount": Number(order.discountAmount),
        "Gross Amount": Number(order.grossAmount),
    }));
};
 
 
export const invoiceDetailExport = async (orderIDs: number[]) => {
    if (!orderIDs || orderIDs.length === 0) {
        return;
    }
    try {
        const response: OrderInvoceDetail[] = await orderServices.getInvoicedetails({ orderIds: orderIDs });
 
        if (!response || response.length === 0) {
            console.warn('No data received from the API.');
            return;
        }
        generateExcelInvoiceDetails(response);
    } catch (error) {
        console.error(`Error fetching or exporting Order Data:`, error);
    }
};
 
const generateExcelInvoiceDetails = (orderList: OrderInvoceDetail[]) => {
    const orderData = orderWiseInvoiceDataDetails(orderList);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(orderData);
    XLSX.utils.sheet_add_aoa(ws, [
        ["Order#", "Invoice#", "Invoice Date", "Total Value", "Handling Charges",
     "Courier Charges", "Packing Charges", "Payment Gateway Charges", "Discount Amount",
     "Gross Amount", "Product Name", "Measurement Unit", "Quantity", "Total Amount"]
    ], { origin: "A1" });
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'InvoceDetailsExport.xlsx');
};
 
const orderWiseInvoiceDataDetails = (orderList: OrderInvoceDetail[]) => {
    return orderList.map(order => ({
       "Order#": order.orderID,
        "Invoice#": order.invoiceNo,
        "Invoice Date": new Date(order.invoiceDate).toLocaleDateString('en-gb'),
        "Total Value": Number(Math.round(order.totalValue)),
        "Handling Charges": Number(order.handlingCharges),
        "Courier Charges": Number(order.courierCharges),
        "Packing Charges": Number(order.packingCharges),
        "Payment Gateway Charges": Number(order.paymentGatewayCharges),
        "Discount Amount": Number(order.discountAmount),
        "Gross Amount": Number(order.grossAmount),
        "Product Name": order.productName,
        "Measurement Unit": order.measurementUnit,
        "Quantity": Number(order.quantity),
        "Total Amount": Number(Math.round(order.totalAmount))
    }));
};
 
 